import React from "react";
import { Heading } from "../../components/style/Heading";
import { ColorPicker } from "../../components/style/ColorPicker";
import { MaterialSelector } from "./MaterialSelector";
import { ContinueButton } from "./ContinueButton";
import { Selector } from "../../components/ui/Selector";

export const Materials = ({
  isActive,
  onComplete,
  items,
  boardManager,
  setOverrideStep,
}) => {
  const { state } = boardManager;
  return (
    <>
      <Heading
        isActive={isActive}
        completed={state.completedMaterials}
        completedAttr={"completedMaterials"}
        setState={boardManager.setState}
        title="Materijal"
        onClick={() => setOverrideStep(0)}
      />

      <div className="styling-wrap__contents | js-conf-styling-wrap-content">
        {!state.completedMaterials && isActive && (
          <MaterialSelector
            items={items}
            activeItem={state.activeItem}
            onSelect={(item) => boardManager.selectMaterial(item)}
          />
        )}

        {state.activeItem && !state.completedMaterials && (
          <>
            {state.activeItem.has_finisher && (
              <Selector
                label="Odaberite vrstu drveta"
                options={state.activeItem.finishers_types}
                selected={state.finisher}
                onSelect={(val) => boardManager.selectFinisher(val)}
              />
            )}

            {state.activeItem.has_types && !state.activeItem.has_finisher && (
              <Selector
                label={state.activeItem.types_text}
                options={state.activeItem.types}
                selected={state.type}
                onSelect={(val) => boardManager.selectType(val)}
              />
            )}

            {!state.activeItem.has_finisher && !state.activeItem.has_types && (
              <ColorPicker
                title="Izbor modela"
                colors={state.activeItem.models}
                handleColorClick={(val) => boardManager.selectColor(val)}
                setCompleted={(completed) =>
                  boardManager.setState((prev) => ({
                    ...prev,
                    completedMaterials: completed,
                  }))
                }
                onComplete={onComplete}
              />
            )}

            {state.finisher &&
              (state.finisher.has_colors ? (
                <ColorPicker
                  title={state.finisher.colors_text}
                  colors={state.finisher.colors}
                  handleColorClick={(val) => boardManager.selectColor(val)}
                  setCompleted={(completed) =>
                    boardManager.setState((prev) => ({
                      ...prev,
                      completedMaterials: completed,
                    }))
                  }
                  onComplete={onComplete}
                />
              ) : (
                <Selector
                  label="Boja"
                  options={[{ name: state.finisher.no_colors_text }]}
                  selected={state.noColors ? { name: state.noColors } : null}
                  onSelect={(val) => boardManager.selectNoColors(val)}
                />
              ))}

            {(state.type || state.noColors) && (
              <ContinueButton
                onClick={() => {
                  boardManager.setState((prev) => ({
                    ...prev,
                    completedMaterials: true,
                  }));
                  onComplete();
                }}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};
